module.exports = __webpack_public_path__ + "static/media/upload_in_progress.723ce349.gif";